import { isEmpty } from 'lodash';
import { CreatorLocationDetail } from '~/screens/MyAgency/components/SearchLocation';
import { ICreator } from '~/types';

function mapPlatforms(platforms: ICreator['platforms']) {
  if (!platforms) return {};
  const result: Record<
    string,
    {
      handle?: string;
      isConnected: boolean;
      followersCount?: number;
      subscriberCount?: number;
      name?: string;
      status?: string;
    }
  > = {};
  Object.keys(platforms).forEach((key) => {
    const platform = platforms[key as keyof ICreator['platforms']];
    result[key] = {
      ...(platform?.handle && { handle: platform.handle }),
      isConnected: platform?.isConnected ?? false,
      ...(platform?.followersCount && {
        followersCount: platform.followersCount,
      }),
      ...(platform?.subscriberCount && {
        subscriberCount: platform.subscriberCount,
      }),
      ...(platform?.name && { name: platform.name }),
      ...(platform?.status && { status: platform.status }),
    };
  });
  return result;
}

function mapManager(manager: ICreator['manager']) {
  if (!manager) return undefined;
  return {
    name: manager.name,
    email: manager.email,
  } as ICreator['manager'];
}

function mapLocation(location: CreatorLocationDetail) {
  if (!location) return {};
  return {
    ...(location?.city && { city: location.city }),
    ...(location?.regionName && { regionName: location.regionName }),
    ...(location?.regionCode && { regionCode: location.regionCode }),
    ...(location?.country && { country: location.country }),
    ...(location?.countryCodeAlpha3 && {
      countryCodeAlpha3: location.countryCodeAlpha3,
    }),
  };
}

function mapCreators(creators: ICreator[]) {
  return creators?.map((creator: ICreator) => {
    const {
      id,
      fullName,
      slug,
      avatar,
      platforms,
      age,
      isOffPlatform,
      categoryAgency,
      bioAgency,
      webLinks,
      genderAgency,
      notes,
      manager,
    } = creator;
    const location = mapLocation(creator.location as CreatorLocationDetail);
    return {
      id,
      fullName,
      slug,
      isOffPlatform,
      ...(avatar && { avatar }),
      ...(age && { age }),
      ...(categoryAgency && { categoryAgency }),
      ...(bioAgency && { bioAgency }),
      ...(genderAgency && { genderAgency }),
      ...(notes && { notes }),
      ...(!isEmpty(webLinks) && { webLinks }),
      ...(!isEmpty(location) && { location }),
      platforms: mapPlatforms(platforms),
      manager: mapManager(manager),
    };
  });
}

export const mapPdfData = (
  creators: ICreator[],
  agencyName?: string,
  agencyLogo?: string,
  listName?: string,
) => {
  return {
    creators: mapCreators(creators),
    agency: {
      name: agencyName,
      ...(agencyLogo && { logo: agencyLogo }),
    },
    listName,
  };
};
